let $filterSiteSelect = $('#filter_child_site')

let $filterYear = $('#filter-year')

if ($filterSiteSelect.length > 0) {
    $filterSiteSelect.on('change', function() {
        window.location.replace($('option:selected', this).attr('data-route'))
    })
}

if ($filterYear.length > 0) {
    $filterYear.on('change', function() {
        window.location.replace($('option:selected', this).attr('data-route'))
    })
}
